const headerSearch = document.querySelector('#header-search');
const search = headerSearch.querySelector('.search');
const form = headerSearch.querySelector('.search__form');
const input = form.querySelector('.search-query');
const searchType = form.querySelector('input[name="type"]').value;
const resultsContainer = headerSearch.querySelector('.search__results-container');
const resultsList = headerSearch.querySelector('.search__results-list');
const resultsOuter = headerSearch.querySelector('.search-outer');
const resultsScroller = headerSearch.querySelector('.search__results-scroller');
let searchRequest;

function removePagination() {
  const pagination = resultsContainer.querySelector('.pagination');

  if (pagination) {
    pagination.remove();
  }
}

function clearSearch() {
  search.classList.remove('search--loading', 'search--loaded');
  resultsList.replaceChildren();
  resultsOuter.replaceChildren();
  removePagination();
}

function renderSearchResults(html) {
  const page = new DOMParser().parseFromString(html, 'text/html');
  const products = page.querySelectorAll('.product-item');
  const resultsText = page.querySelector('.search-results-text');
  const pagination = page.querySelector('.pagination');

  resultsList.replaceChildren(...products);
  resultsOuter.replaceChildren(resultsText);
  removePagination();

  if (pagination) {
    resultsContainer.append(pagination);
  }
}

async function requestSearch(query) {
  search.classList.add('search--loading');
  resultsList.replaceChildren();
  removePagination();

  if (searchRequest) {
    searchRequest.abort();
  }

  searchRequest = new AbortController();

  const params = new URLSearchParams({
    q: query,
    type: searchType,
  });

  const response = await fetch(`/search?${params}`, {
    signal: searchRequest.signal,
  });

  const html = await response.text();

  renderSearchResults(html);
  search.classList.remove('search--loading');
  search.classList.add('search--loaded');
}

async function loadMoreSearchResults(url) {
  search.classList.remove('search--loaded');
  search.classList.add('search--loading');

  const response = await fetch(url);
  const html = await response.text();
  const page = new DOMParser().parseFromString(html, 'text/html');
  const products = page.querySelectorAll('.product-item');
  const nextPage = page.querySelector('.js-loadMore');
  const pagination = resultsContainer.querySelector('.pagination');

  resultsList.append(...products);
  pagination.replaceChildren();

  if (nextPage) {
    pagination.append(nextPage);
  }

  search.classList.remove('search--loading');
  search.classList.add('search--loaded');
}

form.addEventListener('submit', (event) => {
  if (input.value.trim() === '') {
    event.preventDefault();
  }
});

input.addEventListener('keyup', async () => {
  const query = input.value.trim();

  if (query.length === 0) {
    clearSearch();
    return;
  }

  try {
    await requestSearch(query);
  } catch (error) {
    if (error.name !== 'AbortError') {
      throw error;
    }
  }
});

resultsContainer.addEventListener('click', (event) => {
  const loadMore = event.target.closest('.js-loadMore');

  if (!loadMore) {
    return;
  }

  event.preventDefault();
  loadMoreSearchResults(loadMore.href);
});

resultsScroller.addEventListener('scroll', () => {
  const pagination = resultsContainer.querySelector('.pagination');

  if (!pagination || search.classList.contains('search--loading')) {
    return;
  }

  const scrollTriggerPoint = resultsContainer.offsetHeight - resultsScroller.offsetHeight * 2;

  if (resultsScroller.scrollTop >= scrollTriggerPoint) {
    const loadMore = pagination.querySelector('.js-loadMore');

    if (loadMore) {
      loadMore.click();
    }
  }
});




document.querySelector('#header-search .remove-search')?.addEventListener('click', function () {
  this.closest('details').open = false;
});
